export interface ResponseRedirect {
    redirect: string;
}
export interface ResponseError {
    code: number;
    message: string;
    violations?: Record<string, string[]>;
}

export interface CompleteSignUpForm {
    role?: number;
    company?: string;
    companySize?: number;
    referrer?: number;
    phone?: string;
}

export enum Network {
    google = 'google',
    github = 'github',
    microsoft = 'microsoft',
}
